import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
// import Print from 'vue-print-nb'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters'
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
/* import { mockXHR } from '../mock'
if (process.env.NODE_ENV === 'production') {
  mockXHR()
}
*/
import { mockXHR } from '../mock' // global filters

// vxe-table
// import 'xe-utils'

import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'

import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'


import {   
  Tab,
  Tabs,
  Button,
  List,
  PullRefresh,
  Cell,
  Collapse,
  CollapseItem,
  Form,
  Field,
  RadioGroup,
  Radio,
  Calendar,
  DatetimePicker,
  Popup,
  Toast
} from 'vant'

import Print from '@/utils/print' // 引入附件的js文件
Vue.use(Print) // 注册

// vant-ui 
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Button)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Cell)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Form)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Calendar)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Toast);

Vue.use(Viewer)

// Vue.use(Print)
mockXHR()

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.use(VXEUtils, XEUtils)
// Vue.use(VXEUtils)

// vxe-table
Vue.use(VXETable)
VXETable.use(VXETablePluginElement)

// vxe表格配置参数
VXETable.setup({
  // 默认表格参数
  size: 'small',
  showOverflow: null,
  showHeaderOverflow: null,
  align: null,
  headerAlign: null,
  stripe: false,
  border: false,
  resizable: false,
  fit: true,
  showHeader: true,
  highlightCurrentRow: false,
  highlightHoverRow: false,
  highlightCurrentColumn: false,
  highlightHoverColumn: false,
  rowId: '_XID',
  sortConfig: {
    trigger: 'default'
  },
  validConfig: {
    message: 'default'
  },
  // 版本号（对于某些带 Storage 数据储存的功能有用到，上升版本号可以用于重置 Storage 数据）
  version: 0,
  // 自定义图标配置（如果全部图标都使用自定义，就不需要引入 Icon 模块了，减少体积）
  icon: {
    sortAsc: 'vxe-icon--caret-top',
    sortDesc: 'vxe-icon--caret-bottom',
    filter: 'vxe-icon--funnel',
    edit: 'vxe-icon--edit-outline',
    tree: 'vxe-icon--caret-right',
    refresh: 'vxe-icon--refresh',
    custom: 'vxe-icon--menu',
    jumpPrev: 'vxe-icon--d-arrow-left',
    jumpNext: 'vxe-icon--d-arrow-right',
    prevPage: 'vxe-icon--arrow-left',
    nextPage: 'vxe-icon--arrow-right',
    zoomIn: 'vxe-icon--zoomin',
    zoomOut: 'vxe-icon--zoomout',
    modalClose: 'vxe-icon--close',
    modalInfo: 'vxe-icon--info',
    modalSuccess: 'vxe-icon--success',
    modalWarning: 'vxe-icon--warning',
    modalError: 'vxe-icon--error',
    modalQuestion: 'vxe-icon--question',
    modalLoading: 'vxe-icon--refresh roll',
    caretBottom: 'vxe-icon--caret-bottom',
    dropdownBottom: 'vxe-icon--arrow-bottom'
  },
  // 配置式表格的默认参数
  grid: {
    proxyConfig: {
      autoLoad: false,
      message: true,
      props: {
        list: null,
        result: 'data.data.result',
        total: 'data.data.page.total'
      }
    }
  },
  // 默认快捷菜单
  menu: {},
  // 默认 tooltip 主题样式
  tooltip: {
    trigger: 'hover',
    theme: 'dark'
  },
  // 默认分页参数
  pager: {
    pageSize: 10,
    pagerCount: 7,
    pageSizes: [20, 40, 100, 500, 2000, 50000],
    layouts: ['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Sizes', 'Total'] // 非常灵活的分页布局，支持任意位置随意换
  },
  // 默认工具栏参数
  toolbar: {
    refresh: false,
    resizable: {
      storage: false
    },
    setting: {
      storage: false
    },
    buttons: []
  },
  // 默认模态窗口参数
  modal: {
    zIndex: 2000,
    lockView: true,
    lockScroll: true,
    mask: true,
    duration: 3000,
    animat: true
  },
  // 默认优化配置项
  optimization: {
    animat: true,
    // 当表头大于 100 列时自动启用横向 X 滚动渲染
    scrollX: {
      gt: 100
    },
    // 当行数据大于 500 条时自动启用纵向 Y 滚动渲染
    scrollY: {
      gt: 500
    }
  }
})

XEUtils.setup({
  cookies: {
    path: '/'
  },
  treeOptions: {strict: false, parentKey: 'parentId', key: 'id', children: 'children', data: null},
  formatDate: 'yyyy-MM-dd HH:mm:ss.SSS',
  formatString: 'yyyy-MM-dd HH:mm:ss',
  formatStringMatchs: {
    E: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    q: [null, '第一季度', '第二季度', '第三季度', '第四季度']
  },
  commafys: {spaceNumber: 3, separator: ',', fixed: 0}
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js